import type { CycleOperatorSummary } from "./types";

export function summarizeBundle20ExitEnforceLine(
  cycle?: CycleOperatorSummary | null,
): string | null {
  const b = cycle?.bundle20ExitEnforce;
  if (!b || b.operatingMode !== "enforce") return null;
  const parts = [
    `bundle-20 LLM exit enforce ${b.events}`,
    b.byKind.writebackApplied > 0 ? `writeback ${b.byKind.writebackApplied}` : null,
    b.byKind.planRefreshAdmitted > 0 ? `refresh ${b.byKind.planRefreshAdmitted}` : null,
    b.byKind.thesisDecay > 0 ? `thesis ${b.byKind.thesisDecay}` : null,
    b.byKind.domainPanelReplace > 0 ? `panel ${b.byKind.domainPanelReplace}` : null,
  ].filter(Boolean);
  return parts.length > 1 ? parts.join(" · ") : (parts[0] ?? null);
}

export function summarizeBundle20ExitEnforceDetail(
  cycle?: CycleOperatorSummary | null,
): string | null {
  const b = cycle?.bundle20ExitEnforce;
  if (!b) return null;
  const { byKind } = b;
  const segments = [
    byKind.writebackApplied ? `writeback ${byKind.writebackApplied}` : null,
    byKind.planRefreshAdmitted ? `lane-B ${byKind.planRefreshAdmitted}` : null,
    byKind.postTradeRefresh ? `post-trade ${byKind.postTradeRefresh}` : null,
    byKind.thesisDecay ? `thesis ${byKind.thesisDecay}` : null,
    byKind.weakScoutV15 ? `v1.5 ${byKind.weakScoutV15}` : null,
    byKind.stoplossDefer ? `stop defer ${byKind.stoplossDefer}` : null,
    byKind.domainPanelReplace ? `panel ${byKind.domainPanelReplace}` : null,
    byKind.ladderFrontload ? `ladder ${byKind.ladderFrontload}` : null,
  ].filter(Boolean);
  if (!segments.length) return "bundle-20 enforce · 이벤트 0";
  return `bundle-20 enforce · ${segments.join(" · ")}`;
}
